import { render } from "./PedidosPlataformaNew.vue?vue&type=template&id=45a45e58&scoped=true"
import script from "./PedidosPlataformaNew.vue?vue&type=script&lang=js"
export * from "./PedidosPlataformaNew.vue?vue&type=script&lang=js"

import "./PedidosPlataformaNew.vue?vue&type=style&index=0&id=45a45e58&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a45e58"]])

export default __exports__